<template>
  <span>
    <!-- <div
      class="background-wallpaper"
      style="background-image: url(https://wallpapercave.com/wp/wp6896343.jpg)"
    ></div> -->
    <section class="spaced">
      <div class="container content spaced">
        <div class="column c12 text-center spaced">
          <div style="clear: both; height: 100px"></div>
          <h1>VIDEOS</h1>
        </div>
        <div class="column c6 push-center">
          <p class="text-center">
            Explore memories made by the Patronus family, everything from Events to individual gigs.
          </p>
        </div>
      </div>
    </section>

    <section class="spaced">
      <div class="container content">
        <div class="profiles column c12">
            <div v-for="(data, id) in newData" :key="id" class="video-block">
              <iframe
                width="100%"
                height="250px"
                :src="data.src"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            <div class="video-title">
              <i class="fas fa-play-circle player-link"></i>
              <h2>{{ data.title }}</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div style="clear: both; height: 100px"></div>
  </span>
</template>

<script>
import axios from 'axios'
export default {
  name: 'videos',
  title: 'Patronus Records - Videos',
  data () {
    return {
      albums: [],
      id: null,
      newData: [],
      AlbumTypes: [],
      selectedCat: 'all'
    }
  },
  created () {
    axios.get('https://admin.patronusrecords.com/videos').then((response) => {
      response.data.sort(function (a, b) {
        return new Date(b.created_at) - new Date(a.created_at)
      })
      this.albums = response.data
      this.newData = this.albums.map((a) => {
        return {
          title: a.VideoTitle,
          src: 'https://www.youtube.com/embed/' + a.VideoLink + '?controls=1&showinfo=1&modestbranding=1&enablejsapi=1&version=3&fs=1',
          thumb: 'https://img.youtube.com/vi/' + a.VideoLink + '/0.jpg',
          id: a.id
        }
      })
    })
  },
  methods: {
    filter (selection) {
      this.selectedCat = selection
    }
  }
}

</script>
<style scoped>
.artwork {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-size: contain;
}

.card-overlay {
  position: absolute;
  background-color: var(--primary);
  width: 100%;
  padding-bottom: 10px;
  bottom: 10px;
  overflow: visible;
  height: 65px;
}
.video-card {
  float: left;
  font-size: 10px;
}
.content {
  padding: 0px !important;
}
.card-content h2 {
  font-size: 16px;
  text-align: left;
}
.image {
  width: 50%;
  height: 200px;
  float: left;
  border: 1px solid red;
  background-size: contain;
}

.video-block {
  width:50%;
  float:left;
  padding:5px;
  margin-bottom:50px;
}
.video-title {
  padding: 16px;
  background-color:var(--primary);
  position: relative;
  z-index:10;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  min-height:75px;
  text-align: left !important;
}
@media only screen and (max-width: 720px) {
  .video-block {
    width:100%;
  }
  .video-title {
    text-align: left !important
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/videos.vue